module.exports = __webpack_public_path__ + "src/assets/img/page8/9217485e174eb092799f5276eb746879.jpg";